
import { mapGetters } from 'vuex'
import surveyForm from '~/mixins/survey-form'

export default {
    mixins: [surveyForm],
    props: {
        mode: {
            type: String,
            default: 'default',
        },
        title: {
            type: String,
            default: 'Drug Search',
        },
    },
    data () {
        return {
            accountModal: {
                show: false,
                title: 'Create an account',
                tabIndex: 0,
            },
            form: {
                drugs: []
            },
        }
    },
    computed: {
        ...mapGetters([
            'client'
        ]),
        widget () {
            return this.mode === 'widget'
        },
    },
    methods: {}
}
